import { Box, Flex, Image, Picture, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

import { getImgSrcSet } from "helpers/image"

const HeroHeading = styled(Flex).attrs({
  alignItems: { _: "flex-start", tablet: "center" },
  height: "100%",
  justifyContent: { _: "center", tablet: "flex-start" },
  left: 0,
  position: "absolute",
  px: { _: 2, tablet: 10 },
  py: 4,
  top: 0,
  width: "100%",
})``

const Strong = styled(Typography).attrs({
  as: "strong",
  fontWeight: "600",
})``

const AboutUs = () => {
  return (
    <Box containWide>
      <Box position="relative" width="100%">
        <Picture
          alt=""
          fallback="https://cms.jewlr.com/d_cyj_about_hero_92d10a63dd/d_cyj_about_hero_92d10a63dd.jpg"
          srcSet={[
            {
              height: 822,
              media: "(max-width: 767px)",
              sizes: "(max-width: 767px) 100vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_cyj_about_hero_76f8a56c88/m_cyj_about_hero_76f8a56c88.jpg`,
                750
              ),
              width: 750,
            },
            {
              height: 1192,
              media: "(min-width: 768px)",
              sizes: "(max-width: 1920px) 100vw, 1920px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/d_cyj_about_hero_92d10a63dd/d_cyj_about_hero_92d10a63dd.jpg`,
                3840
              ),
              width: 3840,
            },
          ]}
        />
        <HeroHeading>
          <Typography variant="h1">
            Jewelry,
            <br />
            your way
          </Typography>
        </HeroHeading>
      </Box>
      <Box containWide>
        <Box
          display={{ _: "block", desktop: "grid" }}
          gridTemplateColumns="repeat(3, 1fr)"
        >
          <Box pb="12px">
            <Image
              alt=""
              height="auto"
              ratio="1280 / 744"
              sizes="(max-width: 1023) 100vw, (max-width: 1920px) 33vw, 640px"
              srcSet={getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/cyj_about_1_32c5f3d326/cyj_about_1_32c5f3d326.jpg`,
                1280
              )}
              width="1280"
            />
            <Box p={{ _: 2, large: 5 }}>
              <Typography mb={3} variant="h2">
                About Customize Your Jewelry
              </Typography>
              <Typography mb={3} variant="body">
                Customize Your Jewelry, established in 2009 and headquartered in
                Toronto, Canada, specializes in the streamlined development,
                production, and shipping of customizable fine jewelry. We offer
                an expansive selection of high-quality pieces at competitive
                prices for jewelry shops, designers, and online retailers.
              </Typography>
              <Typography variant="body">
                Unlike many retailers who outsource manufacturing, we produce
                all our jewelry on-demand in-house in Toronto, using
                ethically-sourced materials and a blend of proprietary software,
                state-of-the-art equipment, and old-world craftsmanship. As one
                of Canada&apos;s largest jewelry manufacturers and exporters, we
                provide a fun and interactive experience for consumers.
              </Typography>
            </Box>
          </Box>
          <Box pb="12px">
            <Image
              alt=""
              height="auto"
              ratio="1280 / 744"
              sizes="(max-width: 1023) 100vw, (max-width: 1920px) 33vw, 640px"
              srcSet={getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/cyj_about_2_bdd569cf9f/cyj_about_2_bdd569cf9f.jpg`,
                1280
              )}
              width="1280"
            />
            <Box p={{ _: 2, large: 5 }}>
              <Typography mb={3} variant="h2">
                Why Partner with Customize Your Jewelry?
              </Typography>
              <Typography mb={3} variant="body">
                <Strong>Custom Collections</Strong>
                <br />
                Build brand identity and align with market trends through a
                unique product selection tailored to your business.
              </Typography>
              <Typography mb={3} variant="body">
                <Strong>White Glove Service</Strong>
                <br />
                Look beyond simple manufacturing — we are a group of dedicated
                partners offering full-service cooperation, problem-solving, and
                experienced support.
              </Typography>
              <Typography mb={3} variant="body">
                <Strong>15 Years of Experience</Strong>
                <br />
                Benefit from outstanding production times and fast shipping or
                pick-up solutions, thanks to our innovative technology, business
                expertise, and state-of-the-art facilities.
              </Typography>
              <Typography mb={3} variant="body">
                <Strong>Creation through Partnership</Strong>
                <br />
                As a leading North American e-commerce platform, we offer
                end-to-end product development, production, and fulfillment
                solutions tailored to B2B collaboration.
              </Typography>
              <Typography mb={3} variant="body">
                <Strong>What Makes Us Different?</Strong>
                <br />
                We are internationally recognized for redefining global
                standards for personalized jewelry. Our products are hand-made
                by local artisans using sustainable materials.
              </Typography>
              <Typography variant="body">
                In the world of B2B fine jewelry, we invite you to discover an
                exceptional end-to-end experience with Safyre Labs, backed by
                transparent communication, a diverse product selection, and a
                broad customer base.
              </Typography>
            </Box>
          </Box>
          <Box pb="12px">
            <Image
              alt=""
              height="auto"
              ratio="1280 / 744"
              sizes="(max-width: 1023) 100vw, (max-width: 1920px) 33vw, 640px"
              srcSet={getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/cyj_about_3_a973aa10b5/cyj_about_3_a973aa10b5.jpg`,
                1280
              )}
              width="1280"
            />
            <Box p={{ _: 2, large: 5 }}>
              <Typography mb={3} variant="h2">
                Quality Made in Canada
              </Typography>
              <Typography mb={3} variant="body">
                Your jewelry is custom-made in our own workshops in North
                America. We control the quality and production time. We will
                receive your personalized jewellery order in days — not weeks.
              </Typography>
              <Typography mb={4} variant="body">
                Our team of jewelry designers and craftsmen create your
                one-of-a-kind jewelry using your choice of sterling silver or
                solid gold, and genuine or simulated stones.
              </Typography>
              <Image
                alt="Made in Canada"
                ml={{ desktop: "10px" }}
                ratio="108 / 111"
                src={require("images/portal/about-us/badge-cyj-made-in-canada.svg")}
                width={{ _: "72px", desktop: "108px" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AboutUs
